import { useRoleProfileActionButtonsContext } from "PFApp/components/role_profile_action_buttons/context/role_profile_action_buttons_context";
import { ShortlistStateLabel } from "PFApp/components/role_profile_action_buttons/parts/shortlist_state_label";
import { useActivityInvalidate } from "PFCore/hooks/queries/activity";
import { useIsUnbiasedMode } from "PFCore/hooks/use_is_unbiased_mode";
import { Shortlist } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./audit_shortlist_buttons.module.scss";
import { AuditShortlistItemButtons } from "./audit_shortlist_item_buttons";

type AuditShortlistButtonsProps = {
  customButton?: React.ReactNode;
};

export const AuditShortlistButtons = ({ customButton }: AuditShortlistButtonsProps) => {
  const { role, profile, shortlist, areButtonsDisabled, removeProfileFromComparison } =
    useRoleProfileActionButtonsContext();
  const { t } = useTranslation("activities");
  const isUnbiasedMode = useIsUnbiasedMode(role?.reviewers);

  const { invalidate } = useActivityInvalidate();
  const isInterested = role.watchers && role.watchers.find(({ profile: { id } }) => id === profile.id);

  const isShortlisted = !!shortlist;

  const handleUndoClick = () => {
    invalidate([role.id]);
  };

  return (
    <div className={css.root}>
      {(isShortlisted || !!customButton) && (
        <div className={css.labelAndIcons}>
          {isShortlisted && (
            <ShortlistStateLabel
              role={role}
              shortlist={shortlist}
              profile={profile}
              isUndoDisabled={areButtonsDisabled}
              onUndoSuccess={handleUndoClick}
              onShortlistDeleteSuccess={removeProfileFromComparison}
            />
          )}
          {customButton}
        </div>
      )}
      {/* @ts-ignore */}
      <AuditShortlistItemButtons
        role={role}
        shortlistedProfile={shortlist as Shortlist}
        isUnbiasedMode={isUnbiasedMode}
      />
      {isInterested && (
        <small className={css.interested}>{t("show.shortlist.personInterestedInActivity")}</small>
      )}
    </div>
  );
};
